module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_Sammi_CR-p-800-a238b375929b7c76f0281481e3f8fb6f.jpg";